import { defineMessages } from 'react-intl';

export default defineMessages({
  schoolContent: {
    id: 'simulated.contentmap.abilities.schoolContent',
    defaultMessage: 'School Content',
  },
  officialAbility: {
    id: 'simulated.contentmap.abilities.officialAbility',
    defaultMessage: 'Official Ability Code',
  },
  indicator: {
    id: 'simulated.contentmap.abilities.indicator',
    defaultMessage: 'Indicator',
  },
  id: {
    id: 'simulated.contentmap.abilities.id',
    defaultMessage: 'ID',
  },
  curricularComponent: {
    id: 'simulated.contentmap.abilities.curricularComponent',
    defaultMessage: 'Curricular component',
  },
  objectOfKnowledge: {
    id: 'simulated.contentmap.abilities.objectOfKnowledge',
    defaultMessage: 'Object of knowledge',
  },
});
